import { render, staticRenderFns } from "./EformElementEditImage.vue?vue&type=template&id=13bdc467&scoped=true&"
import script from "./EformElementEditImage.vue?vue&type=script&lang=js&"
export * from "./EformElementEditImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bdc467",
  null
  
)

export default component.exports